import { Link } from 'react-router';
import { EmptyState } from '../ui/index.tsx';

export function NotFound() {
  return <EmptyState title="Página no encontrada" action={<Link to="/inicio" className="btn">Ir al inicio</Link>}>La dirección no corresponde a ninguna pantalla.</EmptyState>;
}
